import { ICountry } from '@/modules/seller-management/country/types/countryTypes'
import { ModelApi } from '@/services/api/modelApi'

export class CountryEndpoints extends ModelApi<ICountry> {
  constructor() {
    super('country')
  }
}
